import AdjuntosContainer from '../AdjuntosContainer/AdjuntosContainer';
import EsfirusButtonNative from '@components/ui/Button/EsfirusButtonNative';
import Loader from '@components/ui/Loader/Loader';
import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FileListComponent } from '@screens/TrackHorasList/components/FileListComponent';
import { fichajesService } from '@services/fichajes';
import { useEffect, useMemo, useState } from 'react';
import './ModalDocuments.scss';
import { File } from '@screens/TrackHorasList/types';

function ModalDocuments({ open, setOpen, selectedFichaje }: any) {
  const [formData, setFormData] = useState({ files: [] });
  const [files, setFiles] = useState<Array<File>>([]);
  const [loadingDocuments, setLoadingDocuments] = useState<boolean>(false);
  const [fichajeData, setFichajeData] = useState<any>(null);
  const [loadingFichaje, setLoadingFichaje] = useState<boolean>(true);

  const getDocuments = async () => {
    try {
      setLoadingDocuments(true);
      const { data } = await fichajesService.getDocuments(selectedFichaje);
      setFiles(data?.data?.files || []);
    } catch (error) {
      setFiles([]);
    } finally {
      setLoadingDocuments(false);
    }
  };

  const getFichaje = async () => {
    try {
      setLoadingFichaje(true)
      const { data } = await fichajesService.getById(selectedFichaje);
      setFichajeData(data?.data ?? null)
    } catch (error) {
      setFichajeData(null)
    } finally {
      setLoadingFichaje(false)
    }
  }

  useEffect(() => {
    if (selectedFichaje) {
      getDocuments();
      getFichaje();
    }
  }, [selectedFichaje]);

  const saveDocumentsHandler = async () => {
    await fichajesService.uploadFiles(selectedFichaje, formData.files);

    setOpen(false);
  };

  const loading = useMemo(() => loadingDocuments || loadingFichaje, [loadingDocuments, loadingFichaje]);
  const withUniqueId = useMemo(() => Boolean(fichajeData?.extra?.erp_unique_id), [fichajeData]);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="documents-modal">
        <div className="header">
          <h5 className="text-center">Documentos</h5>
        </div>

        <div className="body">
          {loading ? (
            <Box className="ml-20 mr-20 mt-40">
              <Loader message="Cargando documentos" />
            </Box>
          ) : (
            <>
              <div style={{ padding: '16px', width: '100%' }}>
                {files.length > 0 ? (
                  <FileListComponent files={files} />
                ) : (
                  <p
                    style={{
                      color: '#666',
                      textAlign: 'center',
                      marginTop: '12px',
                    }}
                  >
                    No hay archivos disponibles
                  </p>
                )}
              </div>
              {withUniqueId ? (
                <>
                  <AdjuntosContainer
                    formData={formData}
                    setFormData={setFormData}
                    editable={true}
                    isView={true}
                    showDownload={false}
                  />
                  {!!formData.files.length && (
                    <div style={{ marginTop: '1rem' }}>
                      <EsfirusButtonNative
                        click={saveDocumentsHandler}
                        label={'Subir archivos'}
                      />
                    </div>
                  )}
                </>
              ) : (
                <p
                  style={{
                    color: '#666',
                    textAlign: 'center',
                    marginTop: '12px',
                  }}
                >
                  No se pueden enviar documentos a este fichaje porque no se encuentra su relación en el ERP.
                </p>
              )}
            </>
          )}

          <div className="button-container">
            <EsfirusButtonNative
              label={'Cerrar'}
              className="secondary"
              click={() => {
                setOpen(false);
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ModalDocuments;
